div.input input {
	height: 1.5em;
}

div.input.large input {
	padding-top: 12px;
	padding-bottom: 12px;
}

div.input.medium input {
	padding-top: 8px;
	padding-bottom: 8px;
}

div.input.small input {
	padding-top: 6px;
	padding-bottom: 6px;
}

.textField :global(.MuiFormHelperText-root) {
	margin: 5px 0 0 0;
}

.textField.dark {
	& :global(.MuiOutlinedInput-root) {
		background-color: #282828;
		color: #fff;
		border: 1px solid #8c8c8c;

		&:hover {
			background-color: #737373;
		}
	}

	& .spinnerArrowButton {
		color: #ffffff;
	}

	& .spinnerArrowButton:hover {
		background-color: rgba(255, 255, 255, 0.1);
		color: #ffffff;
	}
}

div.input.limited:global(.MuiInputBase-multiline) {
	padding-bottom: 20px;
}

/** So text doesn't overlap with length indicator*/
div.input.limited {
	padding-right: 55px;
}

.lengthIndicator {
	position: absolute;
	right: 8px;
	font-size: 12px;
	font-weight: 400;
	color: #525252;
	text-align: end;
}

.errorText {
	display: flex;
	align-items: center;
	gap: 5px;
}

.hideNativeArrows {
	-moz-appearance: textfield; /* Firefox */
}

.hideNativeArrows::-webkit-outer-spin-button,
.hideNativeArrows::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.customSpinnerWrapper {
	display: flex;
	flex-direction: column;
	/* margin-right: 8px; */
	z-index: 2;
	/* gap: 0.25rem; */
}

.spinnerArrowButton {
	width: 16px;
	height: 10px;
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 0;
	color: #8b8b8b;
	border-radius: 2px;

	&:hover {
		background-color: rgba(0, 0, 0, 0.05);
		color: #454545;
	}

	&:active {
		background-color: rgba(0, 0, 0, 0.1);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover,
		&:active {
			background-color: transparent;
		}
	}
}
